// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/underscore/modules/identity.js
// module id = 128
// module chunks = 1